

































































import { Component, Vue } from "vue-property-decorator";
import { Icon, Button, Field } from "vant";

Component.registerHooks(["beforeRouteLeave"]);

@Component({
  components: {
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Field.name]: Field
  }
})
export default class Login extends Vue {
  zoneCode = "";
  hidePhone = "";
  form = {
    code: "",
    phone: ""
  };
  isSendVerCode = false;
  isDisabledSendVercode = false;
  verCodeTime = 120;
  verCodeTimer;
  isLoadingAutoSend = true; //首次自动发送短信loading
  isFailAutoSend = false;
  isSuccessAutoSend = false;
  autoSendLoadingText = "正在发送短信";
  autoSendFailText = "短信发送失败,点击重新发送";

  get isDisabledSubmit() {
    return Object.keys(this.form).some(key => {
      return !this.form[key];
    });
  }

  get sendVerCodeText() {
    return this.isSendVerCode ? `(${this.verCodeTime}S)` : "发送验证码";
  }

  created() {
    const userInfo: any = (this as any).$localstorage.get("userInfo") || {};
    const { zone_code, phone } = userInfo;
    
    this.zoneCode = zone_code;
    this.form.phone = phone;
    this.hidePhone = phone.replace(/\d{7}(\d{4})/, "*******$1");
    this.handleAutoSendVerCode();
  }

  beforeRouteLeave(to, from, next) {
    if (this.verCodeTimer) {
      clearInterval(this.verCodeTimer);
    }
    next();
  }

  handleAutoSendVerCode() {
    const params = {
      phone: this.form.phone,
      zone_code: this.zoneCode,
      msg_show: 1,
      type: 5
    };
    this.isLoadingAutoSend = true;
    this.isFailAutoSend = false;
    this.isSuccessAutoSend = false;
    (this as any).$apis
      .sendVerCode(params, { customLoading: true, hideFailMessage: true })
      .then(res => {
        const { code } = res;
        this.form.code = code;
        this.$toast("验证码发送成功");
        this.isSuccessAutoSend = true;
        this.isSendVerCode = true;
        this.setIntervalSendVerCode();
      })
      .catch(e => {
        e.msg;
        
        if (e.msg) {
          this.autoSendFailText = e.msg;
          this.isFailAutoSend = true;
        }
      })
      .finally(() => {
        this.isLoadingAutoSend = false;
      });
  }

  handleSendVerCode() {
    const params = {
      phone: this.form.phone,
      zone_code: this.zoneCode,
      msg_show: 1,
      type: 5
    };
    (this as any).$apis
      .sendVerCode(params)
      .then(res => {
        const { code } = res;
        this.form.code = code;
        this.$toast("验证码发送成功");
        this.isSendVerCode = true;
        this.setIntervalSendVerCode();
      })
      .catch(e => {
        
      });
  }

  setIntervalSendVerCode() {
    this.verCodeTimer = setInterval(() => {
      this.verCodeTime--;
      if (this.verCodeTime == 0) {
        clearInterval(this.verCodeTimer);
        this.verCodeTime = 120;
        this.isSendVerCode = false;
      }
    }, 1000);
  }

  handleSubmit() {
    (this as any).$apis
      .verifyVerCode({
        ...this.form,
        type: 5
      })
      .then(() => {
        this.$router.replace("/trade-password-reset");
      })
      .catch(e => {
        
      });
  }
}
